import type { Category } from '../types/catalog';
import { images } from './images';

export const categories: Category[] = [
  {
    id: 'bijoux',
    name: 'Bijoux & accessoires',
    tagline: 'Boucles d’oreilles, colliers, bagues',
    description:
      'Des bijoux façonnés à la main : laiton martelé, argent recyclé, perles d’eau douce et argile cuite.',
    image: images.catBijoux,
  },
  {
    id: 'mode',
    name: 'Mode & textile',
    tagline: 'Vêtements, chapeaux, sacs, maroquinerie',
    description:
      'Lin teint aux plantes, feutre façonné sur forme, cuir tanné végétal : des pièces cousues pour durer.',
    image: images.catTextile,
  },
  {
    id: 'deco',
    name: 'Décoration & artisanat',
    tagline: 'Céramiques, bois, luminaires, illustrations',
    description:
      'Grès tourné, bois de nos forêts, luminaires et tirages d’artistes pour habiter autrement.',
    image: images.catDeco,
  },
  {
    id: 'local',
    name: 'Produits locaux',
    tagline: 'Savons, miel, gourmandises',
    description:
      'Savons saponifiés à froid, miels de petits ruchers et douceurs préparées par des producteurs voisins.',
    image: images.catLocal,
  },
];
